import { useMutation } from "@tanstack/react-query";

import { getClient } from "services";

import logError from "seneca-common/utils/sentry/logError";

export type TeacherClassesSendParentInvitesResponse = {
  parentInvitesCount: number;
};

export default function useBatchSendTeacherClassesParentInvites({
  onSuccess
}: {
  onSuccess: (data: TeacherClassesSendParentInvitesResponse) => void;
}) {
  return useMutation(
    (classIds?: string[]) => {
      return getClient("classService").teacherClassesSendParentInvites({
        classIds
      });
    },
    {
      onSuccess,
      onError: error => {
        logError(error, {
          message:
            "Class service: failed to batch send teacher classes parent invites"
        });
      }
    }
  );
}
